(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["vessa-return-button"] && !Shopify.designMode) return;
  try {
    (function () {
    var ID_PATTERN = /^[0-9]{6,20}$/;
    var PRODUCT_PATH = /^(\/[a-z]{2}(-[a-z]{2})?)?\/products\/[a-z0-9][a-z0-9_-]*$/i;
    var STORAGE_KEY = 'vessa:sizeGuideReturn';

    function isVariantId(value) {
      return ID_PATTERN.test(String(value == null ? '' : value));
    }

    function safeProductPath(value) {
      if (!value) return null;
      var raw = String(value);
      if (raw.indexOf('\\') !== -1) return null;
      var path = raw.split('?')[0].split('#')[0];
      if (path.charAt(0) !== '/' || path.charAt(1) === '/') return null;
      return PRODUCT_PATH.test(path) ? path : null;
    }

    function stored() {
      try {
        return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null') || null;
      } catch (error) {
        return null;
      }
    }

    function init() {
      var buttons = document.querySelectorAll('[data-vessa-return]');
      if (!buttons.length) return;

      var variantId = null;
      var returnPath = null;

      try {
        var params = new URL(window.location.href).searchParams;
        if (isVariantId(params.get('variant'))) variantId = params.get('variant');
        returnPath = safeProductPath(params.get('return'));
      } catch (error) {
        /* ignore */
      }

      if (!variantId || !returnPath) {
        var saved = stored();
        if (saved) {
          if (!variantId && isVariantId(saved.variant)) variantId = saved.variant;
          if (!returnPath) returnPath = safeProductPath(saved.path);
        }
      }

      if (!variantId) return;

      Array.prototype.forEach.call(buttons, function (button) {
        var base = safeProductPath(button.getAttribute('data-fallback'));
        var target = returnPath || base;
        if (!target) return;

        var anchor = button.getAttribute('data-anchor') || '';
        button.setAttribute(
          'href',
          target + '?variant=' + encodeURIComponent(variantId) + (anchor ? '#' + anchor : '')
        );
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["vessa-size-gate"] && !Shopify.designMode) return;
  try {
    (function () {
    var PENDING_CLASS = 'vessa-size-pending';

    function gate() {
      return document.querySelector('[data-vessa-size-gate]');
    }

    function config() {
      var el = gate();
      if (!el) return null;
      return {
        name: el.getAttribute('data-size-option-name') || '',
        position: el.getAttribute('data-size-option-position') || '',
        product: el.getAttribute('data-product-id') || 'product',
      };
    }

    function isSizeControl(el) {
      if (!el || !el.getAttribute) return false;
      var cfg = config();
      if (!cfg) return false;

      var name = el.getAttribute('data-option-name');
      if (name && cfg.name && name === cfg.name) return true;

      // Sprachunabhaengiger Rueckfall: Horizon schreibt die Optionsposition
      // in data-input-id ("2-0", "2-1", ...).
      var inputId = el.getAttribute('data-input-id');
      if (inputId && cfg.position && inputId.indexOf(cfg.position + '-') === 0) return true;

      return false;
    }

    function sizeControls() {
      var all = document.querySelectorAll(
        'input[data-option-name], option[data-option-name], input[data-input-id], option[data-input-id]'
      );
      var out = [];
      for (var i = 0; i < all.length; i++) {
        if (isSizeControl(all[i])) out.push(all[i]);
      }
      return out;
    }

    function currentSize() {
      var controls = sizeControls();
      for (var i = 0; i < controls.length; i++) {
        var control = controls[i];
        if (control.tagName === 'OPTION') {
          if (control.selected) return control.value;
        } else if (control.checked) {
          return control.value;
        }
      }
      return null;
    }

    function storageKey() {
      var cfg = config();
      return 'vessa:sizeChosen:' + (cfg ? cfg.product : 'product');
    }

    function chosenSize() {
      try {
        return sessionStorage.getItem(storageKey());
      } catch (error) {
        return null;
      }
    }

    function rememberSize(value) {
      if (!value) return;
      try {
        sessionStorage.setItem(storageKey(), value);
      } catch (error) {
        /* ignore */
      }
    }

    function isPending() {
      if (!gate()) return false;
      var controls = sizeControls();
      if (!controls.length) return false;
      var chosen = chosenSize();
      if (!chosen) return true;
      return currentSize() !== chosen;
    }

    function messageEl() {
      return document.querySelector('[data-vessa-size-gate-message]');
    }

    function sync() {
      var pending = isPending();
      var root = document.documentElement;
      if (pending !== root.classList.contains(PENDING_CLASS)) {
        root.classList.toggle(PENDING_CLASS, pending);
      }
      if (!pending) {
        var el = messageEl();
        if (el && !el.hidden) el.hidden = true;
      }
    }

    function scheduleSync() {
      setTimeout(sync, 0);
      setTimeout(sync, 300);
    }

    function askForSize() {
      var el = messageEl();
      if (el && el.hidden) el.hidden = false;

      var controls = sizeControls();
      if (!controls.length || !controls[0].closest) return;
      var group = controls[0].closest('fieldset') || controls[0].closest('.variant-option');
      if (group && group.scrollIntoView) {
        group.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    document.addEventListener(
      'change',
      function (event) {
        var target = event.target;
        if (isSizeControl(target)) {
          rememberSize(target.value);
        } else if (target && target.tagName === 'SELECT' && target.options) {
          var option = target.options[target.selectedIndex];
          if (isSizeControl(option)) rememberSize(option.value);
        }
        scheduleSync();
      },
      true
    );

    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (!target || typeof target.closest !== 'function') return;

        if (target.closest('.add-to-cart-button, button[name="add"]')) {
          if (isPending()) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            askForSize();
            return;
          }
        }

        var label = target.closest('label');
        if (label) {
          var input = label.querySelector('input[data-option-name], input[data-input-id]');
          if (isSizeControl(input)) rememberSize(input.value);
        }

        scheduleSync();
      },
      true
    );

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || !form.getAttribute) return;
        if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
        if (!isPending()) return;
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        askForSize();
      },
      true
    );

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sync);
    } else {
      sync();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["vessa-size-guide-link"] && !Shopify.designMode) return;
  try {
    (function () {
    var ID_PATTERN = /^[0-9]{6,20}$/;
    var STORAGE_KEY = 'vessa:sizeGuideReturn';

    function isVariantId(value) {
      return ID_PATTERN.test(String(value == null ? '' : value));
    }

    function currentVariantId() {
      var input = document.querySelector(
        'form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]'
      );
      if (input && isVariantId(input.value)) return input.value;

      try {
        var fromUrl = new URL(window.location.href).searchParams.get('variant');
        if (isVariantId(fromUrl)) return fromUrl;
      } catch (error) {
        /* ignore */
      }

      return null;
    }

    function matchingLink(target) {
      if (!target || typeof target.closest !== 'function') return null;
      return target.closest('[data-vessa-sg-link], a[href*="/pages/groessenberatung"]');
    }

    document.addEventListener(
      'click',
      function (event) {
        if (event.defaultPrevented || event.button !== 0) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        var link = matchingLink(event.target);
        if (!link) return;

        var variantId = currentVariantId();
        if (!variantId) return;

        var guideUrl =
          (link.dataset && link.dataset.guideUrl) ||
          (link.getAttribute('href') || '/pages/groessenberatung');
        var base = guideUrl.split('?')[0].split('#')[0];
        if (base.charAt(0) !== '/') base = '/pages/groessenberatung';

        var returnPath = window.location.pathname;

        try {
          sessionStorage.setItem(
            STORAGE_KEY,
            JSON.stringify({ variant: variantId, path: returnPath })
          );
        } catch (error) {
          /* ignore */
        }

        event.preventDefault();
        window.location.assign(
          base +
            '?variant=' +
            encodeURIComponent(variantId) +
            '&return=' +
            encodeURIComponent(returnPath)
        );
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
